module.exports = __webpack_public_path__ + "img/logo-returns.38a01dd3.svg";